import layout from '@/layout'

const meta = {
  auth: true,
}

export default {
  path: '/master',
  component: layout,
  children: ((pre) => [
    {
      path: 'fabricAttributes',
      name: `${pre}fabricAttributes`,
      meta: {
        ...meta,
        cache: true,
        title: '面料属性维护',
        head: true,
        funcID: 'T000901',
        PID: 'T00',
      },
      component: () => import('@/views/digital/master/fabricAttributes'),
    },
    {
      path: 'fabricCategory',
      name: `${pre}fabricCategory`,
      meta: {
        ...meta,
        cache: true,
        title: '面料类别维护',
        head: true,
        funcID: 'T000902',
        PID: 'T00',
      },
      component: () => import('@/views/digital/master/fabricCategory'),
    },
    {
      path: 'fabric',
      name: `${pre}fabric`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'T000903',
        PID: 'T00',
      },
      component: () => import('@/views/digital/master/fabric'),
    },
    {
      path: 'fabric/:pageType/:fabricCode?',
      name: `${pre}fabric-detail`,
      meta: {
        ...meta,
        cache: true,
        title: ({ $route }) => {
          const { fabricNo } = $route.query || {}
          return `面料信息维护 | ${fabricNo || 'New'}`
        },
        head: true,
        funcID: 'T000903',
        PID: 'T00',
        pageConfig: { layout: { class: 'bg-transparent p-0' } },
      },
      component: () => import('@/views/digital/master/fabric/detail'),
    },
    {
      path: 'fabricRequest',
      name: `${pre}fabricRequest`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        funcID: 'T000905',
        PID: 'T00',
      },
      component: () => import('@/views/digital/master/fabricRequest'),
    },
    {
      path: 'fabricRequest/:pageType/:fabricRequestCode?',
      name: `${pre}fabricRequest-detail`,
      meta: {
        ...meta,
        cache: true,
        title: ({ $route }) => {
          const { fabricRequestNo } = $route.query || {}
          return `面料开发申请 | ${fabricRequestNo || 'New'}`
        },
        head: true,
        funcID: 'T000905',
        PID: 'T00',
        pageConfig: { layout: { class: 'bg-transparent p-0' } },
      },
      component: () => import('@/views/digital/master/fabricRequest/detail'),
    },
    {
      path: 'fabricStockIn',
      name: `${pre}fabricStockIn`,
      meta: {
        ...meta,
        cache: true,
        title: '面料库存入库',
        head: true,
        funcID: 'T000906',
        PID: 'T00',
      },
      component: () => import('@/views/digital/master/fabricStockIn'),
    },
    {
      path: 'fabricStockInDetail/:pageType/:fabricStockInCode',
      name: `${pre}fabricStockInDetail`,
      meta: {
        ...meta,
        cache: false,
        title: '面料库存入库详情',
        head: false,
        funcID: 'T000906',
        PID: 'T00',
      },
      component: () =>
        import('@/views/digital/master/fabricStockIn/components/detail'),
    },
    {
      path: 'fabricStockOut',
      name: `${pre}fabricStockOut`,
      meta: {
        ...meta,
        cache: true,
        title: '面料领用出库',
        head: true,
        funcID: 'T000907',
        PID: 'T00',
      },
      component: () => import('@/views/digital/master/fabricStockOut'),
    },
    {
      path: 'fabricStockOutDetail/:pageType/:fabricStockOutCode',
      name: `${pre}fabricStockOutDetail`,
      meta: {
        ...meta,
        cache: false,
        title: '面料领用出库详情',
        head: false,
        funcID: 'T000907',
        PID: 'T00',
      },
      component: () =>
        import('@/views/digital/master/fabricStockOut/components/detail'),
    },
    {
      path: '/fabric/stock',
      name: `${pre}fabric-stock`,
      meta: {
        ...meta,
        cache: true,
        title: '面料库存查询',
        head: true,
        funcID: 'T000908',
        PID: 'T00',
      },
      component: () => import('@/views/digital/master/fabricStock'),
    },
    {
      path: '/fabric/stockChangeLog',
      name: `${pre}stockChangeLog`,
      meta: {
        ...meta,
        cache: true,
        title: '面料库存日志',
        head: true,
        funcID: 'T000909',
        PID: 'T00',
      },
      component: () => import('@/views/digital/master/stockChangeLog'),
    },
    {
      path: 'fabricRequestSelect',
      name: `${pre}fabricRequestSelect`,
      meta: {
        ...meta,
        cache: true,
        title: '面料申请汇总查询',
        head: true,
        funcID: 'T000910',
        PID: 'T00',
      },
      component: () => import('@/views/digital/master/fabricRequestSelect'),
    },
    {
      path: 'fabricExpenseRequest',
      name: `${pre}fabricExpense`,
      meta: {
        ...meta,
        cache: true,
        title: '面料开发请款',
        head: true,
        funcID: 'T000911',
        PID: 'T00',
      },
      component: () => import('@/views/digital/master/fabricExpense'),
    },
    {
      path: 'fabricExpenseRequest/:pageType/:code?/:type?',
      name: `${pre}fabricExpense-detail`,
      meta: {
        ...meta,
        cache: true,
        title: ({ $route }) => {
          const { fabricExpenseNo = '' } = $route.query || {}
          return `面料开发请款 | ${fabricExpenseNo || 'New'}`
        },
        head: true,
        funcID: 'T000911',
        PID: 'T00',
      },
      component: () => import('@/views/digital/master/fabricExpense/detail'),
    },
    {
      path: 'greyfabric',
      name: `${pre}greyfabric`,
      meta: {
        ...meta,
        cache: true,
        title: '面料坯布维护',
        head: true,
        funcID: 'T000912',
        PID: 'T00',
      },
      component: () => import('@/views/digital/master/greyfabric'),
    },
    {
      path: 'cardMaintenance',
      name: `${pre}cardMaintenance`,
      meta: {
        ...meta,
        cache: true,
        title: '面料卡维护',
        head: true,
        funcID: 'T000913',
        PID: 'T00',
      },
      component: () => import('@/views/digital/master/cardMaintenance'),
    },
  ])('master-'),
}
